import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup, Radio, FormGroup } from '@mui/material';
import ModalFooter from "../Modal/ModalFooter/ModalFooter";
import ModalHeader from "../Modal/ModalHeader/ModalHeader";

export default function StepOne(props) {
    const [button, setButton] = useState(
        {
            'function': props.next,
            'text': 'Suivant',
            'disabled': true,
            'color': 'success'
        });

    useEffect( () => {
        if(props.datas.conditions){
            button.disabled = false;
        }else{
            button.disabled = true;
        }
        setButton({...button});
    }, [props.datas]);

    function handleModeChange(e){
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    function handleConditionChange(e){
        let datas = Object.assign({}, props.datas);
        datas.conditions = e.target.checked;
        props.handleChange(datas);
    }

    return (
        <>
            <ModalHeader text='Consentement' />
            <Typography id="modal-modal-description" variant="p">
                La Commission publiera toutes les contributions à la présente consultation publique. Vous pouvez choisir soit d’autoriser la publication de vos coordonnées, soit de rester anonyme lors de la publication de votre contribution. Dans un souci de transparence, le type de répondant (par exemple, «association d’entreprises», «organisation de défense des consommateurs», «citoyen de l’Union»), le pays d’origine, le nom et la taille de l’organisation, ainsi que son numéro d’inscription au registre de transparence, sont toujours publiés. Votre adresse électronique ne sera jamais publiée. Veuillez choisir l’option en matière de protection de la vie privée qui vous convient le mieux. Des options en matière de protection de la vie privée sont définies par défaut en fonction du type de répondant sélectionné.
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                * QuestionParamètres de confidentialité pour la publication de la contribution
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        name="radio-buttons-group">
                        <FormControlLabel value="public" control={<Radio name='mode' onChange={(e) => handleModeChange(e)}/>} label="Mode Public"/>
                        <Typography id="modal-modal-description" variant="p">
                            Publication des informations relatives à l’organisation uniquement: le type de répondant choisi pour répondre à la présente consultation, le nom de l’organisation au nom de laquelle vous répondez ainsi que son numéro d’inscription au registre de transparence, sa taille, son pays d’origine et votre contribution seront publiés tels quels. Votre nom ne sera pas publié. Veuillez ne pas inclure de données à caractère personnel dans la contribution proprement dite si vous souhaitez rester anonyme.
                        </Typography>
                        <FormControlLabel value="anonymous" control={<Radio name='mode' onChange={(e) => handleModeChange(e)}/>} label="Mode Anonyme" />
                        <Typography id="modal-modal-description" variant="p">
                            Publication des informations relatives à l’organisation et au répondant: le type de répondant choisi pour répondre à la présente consultation, le nom de l’organisation au nom de laquelle vous répondez ainsi que son numéro d’inscription au registre de transparence, sa taille, son pays d’origine et votre contribution seront publiés. Votre nom sera également publié.
                        </Typography>
                    </RadioGroup>
                </FormControl>
                <FormGroup>
                    <FormControlLabel control={<Checkbox name='conditions' onChange={(e) => handleConditionChange(e)}/>} label={'J’accepte les '} checked={props.datas.conditions} /><a href='https://ec.europa.eu/info/law/better-regulation/specific-privacy-statement' target='_blank'>dispositions relatives à la protection des données à caractère personnel</a>
                </FormGroup>
            </Typography>
            <ModalFooter buttons={[button]}/>
        </>
    )
}